import styles from './Spinner.module.css'

export function Spinner({
  label,
  fullPage = false,
}: {
  label: string
  fullPage?: boolean
}) {
  return (
    <div
      className={`${styles.container} ${fullPage ? styles.fullPage : ''}`}
      role="status"
    >
      <span className={styles.spinner} aria-hidden="true" />
      <span>{label}</span>
    </div>
  )
}
